<div class="login-wrapper no-select">
    <div class="login-component">
      <div class="center-children margin-top-xl">
        <a routerLink="/" class="logo-link">
            <app-image class="logo-authentication " src="assets/logos/logo_wetalk.png" alt="logo"
                height="46" width="212" priority />
        </a>
      </div>
      <div class="grow column center-children ">
        <div class="header margin-top">
          <h2>Tester la plateforme</h2>
        </div>
        <form class="login-form" [formGroup]="loginForm" (submit)="validate()">
            <app-input [error]="formError" [error-message]="''" formControlName="firstname" type="default"
                        placeholder="Prénom"></app-input>
            <app-input [error]="formError" [error-message]="''" formControlName="lastname" type="default"
                        placeholder="Nom de famille"></app-input>
            <app-input [error]="formError" [error-message]="''" formControlName="email" type="email"
                        placeholder="Email"></app-input>
            <div *ngIf="showEmailAlreadyExistsError" class="invalid-code-error">
                <app-icon type="danger" class="error-icon"></app-icon>
                <p>
                    Cet email est déjà utilisé. 
                    <a (click)="handleForgotPasswordClick()" href="auth/forgotten-password" class="error-email">Mot de passe oublié ?</a> 
                </p>
            </div>
            <app-radio-buttons
                        title="Genre"
                        [options]="genderPossibilities"
                        formControlName="gender"
                    ></app-radio-buttons>
            <div class="row gap center-children-vertically margin-bottom margin-top">
                <p>Je suis</p>
                <div class="half-width row gap center-children-vertically">
                    <div class="quota-input-wrapper">
                        <app-input
                            formControlName="accountType"
                            [margin-bottom]="false"
                            type="number"
                            [dropdownData]="options"
                        ></app-input>
                    </div>
                </div>
            </div>
            <div *ngIf="isCompany()" class="margin-top">
                <app-input 
                  [error]="formError" 
                  [error-message]="''" 
                  formControlName="companyName" 
                  type="default"
                  placeholder="Nom de l'entreprise">
                </app-input>
            </div>
            <app-input [correct]="phoneWork" class="form-input"
                [phoneCode]="phoneRegionCode"
                (selectPhoneCode)="selectPhoneRegionCode($event)"
                type="phone"
                formControlName="phoneNumber"
                placeholder="0612345678"></app-input>
            <div *ngIf="isInvalid" class="error-message text-center">
                Veuillez remplir correctement tous les champs obligatoires.
            </div>
            <div class="column gap center-children">
              <app-button 
                [disabled]="formState === 'submitting'" 
                class="submit-button margin-bottom" 
                type="submit">{{ buttonMessage }}</app-button>
            </div>
            <div *ngIf="successMessage.length" class="success-message">
                {{successMessage}}
              </div>
        </form>
      </div>
    </div>
    <div class="introduce-part">
      <img class="full-screen" src="assets/images/background.png" alt="background2"/>
      <div class="introducing-text">
        <img class="quote"  src="assets/images/quotes.svg" alt="quotes"/>
        <h1 style="text-transform: initial">Relève tes défis, traverse les épreuves, entame ta transformation…</h1>
      </div>
    </div>
  </div>
  